const ITEMS = [
  "Cruelty-Free",
  "Organic Ingredients",
  "Conscious Beauty",
  "One-to-One Care",
  "Non-Toxic Formulas",
  "Vegan Principles",
  "Timeless Craft",
];

function Row() {
  return (
    <div className="flex items-center shrink-0">
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display italic font-light text-3xl md:text-5xl text-[#F9FAF8]/90 px-8 md:px-12 whitespace-nowrap">
            {t}
          </span>
          <svg viewBox="0 0 24 24" className="w-4 h-4 text-[#8EA696] shrink-0" fill="currentColor" aria-hidden="true">
            <path d="M12 2 C14 8 16 10 22 12 C16 14 14 16 12 22 C10 16 8 14 2 12 C8 10 10 8 12 2 Z" />
          </svg>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="bg-[#11261A] py-7 md:py-9 overflow-hidden border-y border-[#1B3B28]" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
}
